import { forEach } from "../../../framework/utils/collection";
import { buildBlockquoteComponentModel } from "./blockquote";
import { IComponentSource, ComponentModel, MarkdownComponent, ComponentSource, getMarkdownLines, distillComponentSource } from "./core";
import { buildHorizontalRuleComponentModel } from "./horizontal-rule";
import { buildListComponentModel } from "./list";
import { buildParagraphComponentModel, buildHeadingComponentModel } from "./paragraph-header";
import { sanitizeMarkdown } from "./sanitization";
import { buildTableComponentModel } from "./table";
import { buildTimingSpecComponentModel, ITimingSpecComponentModel, TimingSpecComponentModel } from "./timing-spec";


const toComponentModel = (source: IComponentSource): ComponentModel => {
  if(source.type === MarkdownComponent.OrderedList || source.type === MarkdownComponent.UnorderedList) {
    return buildListComponentModel(source);
  } else if(source.type === MarkdownComponent.Table) {
    return buildTableComponentModel(source);
  } else if(source.type === MarkdownComponent.Blockquote) {
    return buildBlockquoteComponentModel(source);
  } else if(source.type === MarkdownComponent.TimingSpec) {
    return buildTimingSpecComponentModel(source);
  } else if(source.type === MarkdownComponent.Paragraph) {
    return buildParagraphComponentModel(source);
  } else if(source.type === MarkdownComponent.Heading) {
    return buildHeadingComponentModel(source);
  } else if(source.type === MarkdownComponent.ThickRule || source.type === MarkdownComponent.ThinRule) {
    return buildHorizontalRuleComponentModel(source);
  }

  // this won't ever happen (hopefully)
  return buildParagraphComponentModel(source);
}
const buildComponentModels = (source: IComponentSource[]) => {
  const componentModels = source.map(toComponentModel);
  return componentModels;
}

const distillComponentModels = (models: ComponentModel[]) => {
  const distilledModels: ComponentModel[] = [];
  if(models.length === 0) { return models; }

  let currentSpec: ITimingSpecComponentModel | null = models[0].type !== MarkdownComponent.TimingSpec ?
  new TimingSpecComponentModel(new ComponentSource(MarkdownComponent.TimingSpec)) : null;

  forEach(models, model => {
    if(model.type === MarkdownComponent.TimingSpec) {
      if(currentSpec !== null) { distilledModels.push(currentSpec); }
      currentSpec = model as ITimingSpecComponentModel;
    } else {
      currentSpec!.notes.push(model);
    }
  });
  if(currentSpec !== null) { distilledModels.push(currentSpec); }

  return distilledModels;
};

export const toMarkdownComponentModels = (markdown: string) => {
  const md = sanitizeMarkdown(markdown);
  const mdLines = getMarkdownLines(md);
  const source = distillComponentSource(mdLines);
  const models = buildComponentModels(source);

  return models;
}

export const toPresentationComponentModels = (markdown: string) => {
  const models = toMarkdownComponentModels(markdown);
  const specModels = distillComponentModels(models);

  return specModels;
}